<template>
    <div class="mobile-pull-container">
        <div class="pull-down-header" :style="{'height': scorllY + 'px'}">
            <template v-if="pullDownLoading && scorllY < 60">
                <div class="pull-down-prompt" v-if="scorllY != maxY">
                    <div>
                        <p ><i v-if="pullDownLoadingStart" class="iconfont icon-jiazai"></i>释放即可刷新</p>
                        <span v-if="!pullDownLoadingStart" :class="scorllY == 59 ? 'active' : ''" >
                            <i class="iconfont icon-drop-down"></i>
                        </span>
                    </div>
                </div>
            </template>
            <template v-if="pullDownLabel && ((pullDownLoading && scorllY > 60) || !pullDownLoading)">
                <div class="pull-down-prompt" v-if="scorllY != maxY">
                    <div>
                        <p>下拉展示历史标签页</p>
                        <i class="iconfont icon-drop-down"></i>
                    </div>
                </div>
                <TagRouterList @handleClickRetract="handleClickRetract"></TagRouterList>
                <div v-if="scorllY == maxY"  class="pull-down-retract" @click="handleClickRetract">收起</div>
            </template>


        </div>
        <div class="content"  ref="content_container" @touchstart="touchstart" @touchmove="touchmove" @touchend="touchend" >
            <slot name="container"></slot>
        </div>
    </div>
</template>

<script>
import TagRouterList from "./TagRouterList";
import { mapState } from 'vuex'
export default {
    name: "PullContainer",
    components: {
        TagRouterList
    },
    props: {
        pullDownLoading: {
            type: Boolean,
            default: false,
        },
        pullDownLabel: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            pullDownLoadingStart:false,
            scorllY: 0,
            startY: 0,
            maxY:0,
            historical_tags:[
                {title:'标签页名称—标签父级名称',path:''},
            ]
        }
    },
    computed: {
        ...mapState(['tagList'])
    },
    created() {

    },
    mounted() {
        // 获取屏幕高度
        const screenHeight = window.innerHeight || document.documentElement.clientHeight;
        // 设置最大顶部距离（-200，目的是让一楼漏出头，方便上划，或者点击）
        this.maxY = screenHeight - 0;
    },
    methods:{
        touchstart(event) {
            this.startY = event.touches[0].clientY;
        },
        touchmove(event) {

            if(event.path && event.path.length > 0){
                const hasVanPopup = event.path.some(element => {
                    return element.classList && element.classList.contains('van-popup');
                });
                if (hasVanPopup) {
                  return  false
                }
            }

            const target = event.target;
            let currentElement = target;
            while (currentElement) {
                if (currentElement.scrollTop > 0) {
                    // 如果当前元素的 scrollTop > 0，阻止上层拖动
                    event.stopPropagation();
                    return;
                }
                currentElement = currentElement.parentElement;
            }
            if(!this.pullDownLoading && !this.pullDownLabel) return false
            if(this.$refs.content_container.querySelectorAll('.mobile_container') &&
                this.$refs.content_container.querySelectorAll('.mobile_container').length > 0 ){
                if(this.$refs.content_container.querySelectorAll('.mobile_container')[0].scrollTop < 0){
                    this.$refs.content_container.querySelectorAll('.mobile_container')[0].scrollTop = 0
                }



                if(this.$refs.content_container.querySelectorAll('.mobile_container')[0].scrollTop == 0){
                    let currentY = event.touches[0].clientY;
                    let distance = currentY - this.startY;

                    if(this.pullDownLoading && distance > 60 && distance < 200){
                        distance = 59

                    }
                    if(!this.pullDownLabel){
                        distance = 79
                    }
                    this.scorllY = Math.max(0, distance); // 防止负值
                }

            }
        },
        touchend() {
            // 可以在这里添加动画或重置 y 的逻辑
            if(this.scorllY == 59 && this.pullDownLoading){
                this.$emit('pullDownLoadingSuccess', true)
                this.pullDownLoadingStart = true
                return false
            }
            if(this.scorllY > 200){
                this.scorllY = this.maxY
            }else{
                this.scorllY = 0; // 结束时重置高度
                this.pullDownLoadingStart = false
            }
        },
        // 收起
        handleClickRetract(flag){
            this.scorllY = 0;
            this.pullDownLoadingStart = false
        },
        pullDownLoadingEnd(message){
            this.scorllY = 0
            this.pullDownLoadingStart = false
            this.$toast(message ? message : '加载完毕')
        },

    }
}
</script>

<style lang="scss"  scoped>
.mobile-pull-container{
    height: 100vh;
    overflow: hidden;
    background-color: #fff;
}
.pull-down-header {
    width: 100%;
    height: 0;
    overflow: hidden;
    position: relative;
    background-color: rgba(28, 34, 41, 1);
    transition: height 0.3s ease;
    z-index: 1001;

    .pull-down-prompt {
        width: 100%;
        height: 100%;
        text-align: center;
        display: flex;

        padding: 12px;
        box-sizing: border-box;
        justify-content: center;
        position: absolute;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.3);
        backdrop-filter: blur(2px);
        p {
            font-size: 12px;
            font-weight: bold;
            color: #fff;
            i{
                margin-right: 8px;
                animation: spin 2s linear infinite;
                margin-top: 2px;
                display: inline-block;
            }
        }
        span{
            display: inline-block;
            transition: .5s all;
            &.active{
                transform: rotate(-180deg)
            }
        }

        i {
            margin-bottom: 4px;
            font-size: 14px;
            color: #fff;
        }
    }



    .pull-down-retract {
        position: absolute;
        left: 0;
        bottom: 0;
        height: 78px;
        opacity: 1;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        background: rgba(61, 75, 89, 1);
        text-align: center;
        padding: 10px;
        line-height: 24px;
        box-sizing: border-box;
        font-size: 16px;
        color: rgba(255, 255, 255, 1);
        width: 100%;
    }
}
@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
.content{
    width: 100%;
    height: 100vh;
    background: rgba(247, 248, 250, 1);
}
</style>
